import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  keyLoading,
  resetForeignRegions,
  selectForeignRegions,
  selectLoading,
} from './store/slice'
import { getForeignRegionsThunk } from './store/thunk'

let cacheKey = null

const useGetForeignRegions = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const loading = useSelector(selectLoading(keyLoading.FOREIGN_REGIONS))
  const foreignRegions = useSelector(selectForeignRegions)

  useEffect(() => {
    if (cacheKey !== locale) {
      cacheKey = locale
      dispatch(getForeignRegionsThunk())
    }
  }, [locale])

  useEffect(() => {
    return () => dispatch(resetForeignRegions())
  }, [])

  return {
    loading,
    foreignRegions,
  }
}

export default useGetForeignRegions
